import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`

export const RightHeadContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`

export const InstanceName = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${props => props.theme.colors.text};
`

export const NavWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
`
